// extracted by mini-css-extract-plugin
export default {"div":"Form_div__JHmtn","label":"Form_label__1TBaf","input":"Form_input__8c+8Y","error":"Form_error__kY8hF","formButton":"Form_formButton__oBLaj"};